<template>
  <detail-layout-two-columns-no-fixed-collapsible :custom-right="summaryWidth" :collapsed="collapsed" @update:collapsed="$emit('update:collapsed', $event)">
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
      </div>
    </template>
    <template slot="LeftCol">
      <div class="form-wrapper px-4 lg:px-10">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-row w-full md:w-11.5/12 lg:max-w-detailinvoice"
          autocomplete="off"
        >
          <div class="flex-1">

            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">       
              <div class="w-full" >
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.serie_factura') }}</label>
                <el-form-item prop="serieFactura" class="w-full">
                  <base-el-select v-model="form.serieFactura" :options="seriesFactura" :loading="isLoadingSeries" :disabled="!isInInvoicesIssuingType && !isInSimplifiedIssuingType"
                    allow-create clearable filterable :exclude-falsys="['']" :option-label="serieFacturaLabel" />
                </el-form-item>
              </div>
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('invoices.num_factura') }}</label>
                <el-form-item prop="numFactura">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.numFactura"
                    maxlength="20"
                    :disabled="true"
                  />
                </el-form-item>
              </div>
            </div>

            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
              <div>
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('invoices.fecha_emision') }}</label>
                <el-form-item prop="dateEmision">
                  <el-date-picker v-model="form.dateEmision" type="date" :picker-options="dateRangeOptions"
                    :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]"></el-date-picker>
                </el-form-item>
              </div>
            </div>

            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
              <div class="w-full">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.num_albaran') }}</label>
                  <el-form-item prop="albaran">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.albaran"
                      maxlength="30"
                    />
                  </el-form-item>
              </div>

              <div class="w-full">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.step2.numero_pedido') }}</label>
                  <el-form-item prop="pedido">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.pedido"
                      maxlength="20"
                    />
                  </el-form-item>
              </div>
            </div>

            <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="!hasVerifactu"/>{{ $t('invoices.invoices_issuing.observaciones') }}</label>
                <el-form-item prop="observaciones">
                  <el-input type="textarea" :rows="3" clearable class="w-full"
                    v-model="form.observaciones" maxlength="2500" />
                </el-form-item>
            </div>

            <base-collapsible-form ref="baseCollapsibleTributacion" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('invoices.invoices_issuing.step2.tributacion_header') }}</h4>
              </template>
              <template slot="content">
                 <el-switch 
                    class="switch-text break-normal mb-4" 
                    v-model="form.applyEquivalenceSurcharge" 
                    :active-text="$t('impuestos.equivalence_surcharge_apply')"/>
                <label class="text-sm font-semibold text-secondary-600 block mb-4">{{ $t('invoices.invoices_issuing.step2.operacion_title') }}</label>
                <el-radio-group v-model="form.tipoImpuestoFactura" class="flex flex-row md:inline-block align-middle" :size="isLower1024 ? 'mini' : ''">
                  <el-radio-button class="border-l-0 dark:border-darkblue-300 items-center" :label="0">
                    <div class="flex flex-row items-center h-6">
                      {{ $t('invoices.invoices_issuing.step2.normal') }}
                    </div>
                  </el-radio-button>
                  <el-radio-button class="dark:border-darkblue-300" :label="1">
                    <div class="flex flex-row items-center h-6">
                      {{ $t('invoices.invoices_issuing.step2.exenta') }}
                      <base-tooltip-icon size="sm" :content="exentaTooltipMessage" placement="top" class="ml-1"/>    
                    </div>
                  </el-radio-button>
                  <el-radio-button class="dark:border-darkblue-300" :label="2">
                    <div class="flex flex-row items-center h-6">
                      {{ $t('invoices.invoices_issuing.step2.no_sujeta') }}
                      <base-tooltip-icon size="sm" :content="noSujetaTooltipMessage" placement="top" class="ml-1"/>    
                    </div>
                  </el-radio-button>
                  <el-radio-button class="dark:border-darkblue-300" :label="3">
                    <div class="flex flex-row items-center h-6">
                      {{$t('invoices.invoices_issuing.step2.sujeto_pasivo')}}
                    </div>
                  </el-radio-button>
                </el-radio-group>

                <!-- IRPF, Suplidos y Fechas de Facturación -->
                <step-3-others ref="embedded-step" class="embedded-step" :is-first-step="isFirstStep" :step="{}" :value="value" @input="$emit('input', $event)" />
              </template>
            </base-collapsible-form>

            <!-- Periodo -->
            <base-collapsible-form ref="baseCollapsiblePeriodo" v-model="form.periodoMain" @clearForm="clearPeriodo"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('invoices.invoices_issuing.periodo') }}</h4>
              </template>
              <template slot="content">
                <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.from') }}</label>
                    <el-form-item prop="periodoDesde">
                      <el-date-picker v-model="form.periodoDesde" type="date" value-format="yyyy-MM-dd[T00:00:00]" 
                        :format="datePattern"></el-date-picker>
                    </el-form-item>
                  </div>
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.to') }}</label>
                    <el-form-item prop="periodoHasta">
                      <el-date-picker v-model="form.periodoHasta" type="date" value-format="yyyy-MM-dd[T00:00:00]" 
                        :format="datePattern"></el-date-picker>
                    </el-form-item>
                  </div>
                </div>
              </template>
            </base-collapsible-form>
            <!-- End Periodo -->

            <base-collapsible-form ref="baseCollapsible" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('invoices.invoices_issuing.contracting_and_order_data') }}</h4>
              </template>
              <template slot="content">
                <base-ro-input-inline class="mb-2 text-sm" :label="$t('invoices.invoices_issuing.expediente')" />
                <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.numero') }}</label>
                    <el-form-item prop="numExpediente">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.numExpediente"
                        maxlength="20"
                        @change="validateFields('dateExpediente', $event)"
                        @clear="validateFields('dateExpediente')"
                      />
                    </el-form-item>
                  </div>
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.date') }}</label>
                    <el-form-item prop="dateExpediente">
                      <el-date-picker v-model="form.dateExpediente" type="date" value-format="yyyy-MM-dd[T00:00:00]" 
                        :format="datePattern" :picker-options="dateRangeOptions" @change="value => validateFields(value, 'numExpediente')"></el-date-picker>
                    </el-form-item>
                  </div>
                </div>
                
                <base-ro-input-inline class="mb-2 text-sm" :label="$t('invoices.invoices_issuing.pedido_emisor')" />
                <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.numero') }}</label>
                    <el-form-item prop="numEmisor">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.numEmisor"
                        maxlength="20"
                        @change="validateFields('dateExpediente', $event)"
                        @clear="validateFields('dateExpediente')"
                      />
                    </el-form-item>
                  </div>
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.date') }}</label>
                    <el-form-item prop="dateEmisor">
                      <el-date-picker v-model="form.dateEmisor" type="date" value-format="yyyy-MM-dd[T00:00:00]" 
                        :format="datePattern" :picker-options="dateRangeOptions" @change="value => validateFields(value, 'dateExpediente')"></el-date-picker>
                    </el-form-item>
                  </div>
                </div>
                
                <base-ro-input-inline class="mb-2 text-sm" :label="$t('invoices.invoices_issuing.contrato')" />
                <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.cod_asignacion_receptor') }}</label>
                    <el-form-item prop="codAsignacion">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.codAsignacion"
                        maxlength="20"
                        @change="validateFields('dateReceptor', $event)"
                        @clear="validateFields('dateReceptor')"
                      />
                    </el-form-item>
                  </div>
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.date') }}</label>
                    <el-form-item prop="dateReceptor">
                      <el-date-picker v-model="form.dateReceptor" type="date" value-format="yyyy-MM-dd[T00:00:00]" 
                        :format="datePattern" :picker-options="dateRangeOptions" @change="validateFields('codAsignacion', $event)"></el-date-picker>
                    </el-form-item>
                  </div>
                </div>
                
                <!-- v-if="faceb2b" -->
                <base-ro-input-inline class="mb-2 text-sm" :label="$t('invoices.invoices_issuing.licitacion')" />
                <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.dir3_licitacion') }}</label>
                    <el-form-item prop="dir3">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.dir3"
                        maxlength="20"
                        @change="validateFields('numContrato', $event)"
                        @clear="validateFields('numContrato')"
                      />
                    </el-form-item>
                  </div>
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.num_contrato') }}</label>
                    <el-form-item prop="numContrato">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.numContrato"
                        maxlength="20"
                        @change="validateFields('dir3', $event)"
                        @clear="validateFields('dir3')"
                      />
                    </el-form-item>
                  </div>
                </div>
                <div class="lg:mb-2">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.cod_dep_receptor') }}</label>
                  <el-form-item prop="codDepReceptor">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.codDepReceptor"
                      maxlength="20"
                    />
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="RightCol">
      <slot name="invoice-summary" />
    </template>
    <template slot="layout-extend">
      <slot name="layout-extend" :valid="isValid" />
    </template>
  </detail-layout-two-columns-no-fixed-collapsible>
</template>

<script>
import DetailLayoutTwoColumnsNoFixedCollapsible from '@/components/layout/DetailLayoutTwoColumnsNoFixedCollapsible.vue'
import Step3Others from '@/views/invoices/issuingSteps/Step3Others.vue'
import { i18n } from '@/i18n'
// import UserGeneratePasswordDialog from '@/components/UserGeneratePasswordDialog.vue'
import { getNextInvoiceDefault } from '@/services/configurations/getNextInvoiceDefault'
import { getNextInvoicePresupuestoProforma } from '@/services/configurations/getNextInvoicePresupuestoProforma'
import { getSeries } from '@/services/configurations/getSeries'
import { getValidateVerifactu } from '@/services/configurations/getValidateVerifactu'
import { checkInvoiceNumber } from '@/services/configurations/checkInvoiceNumber'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import { recalculate } from '@/services/functions/lines/lineCalcs'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  /* eslint-disable camelcase */
  name: 'step2-detail',
  components: {
    DetailLayoutTwoColumnsNoFixedCollapsible,
    Step3Others,
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
    summaryWidth: {
      type: [Array, Object, String],
      default: 'w-full'
    },
    collapsed: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      stepId: '2',
      vuexnamespace: 'invoicesIssuing/2',
      isLoadingSeries: false,
      seriesFactura: [],
      hasVerifactu: true,
      dateRangeOptions: {
        firstDayOfWeek: 1,
        // disabledDate: this.disabledFutureDates
      },
      exentaTooltipMessage: i18n.t('invoices.invoices_issuing.step2.exenta_tooltip'),
      noSujetaTooltipMessage: i18n.t('invoices.invoices_issuing.step2.no_sujeta_tooltip'),
      rules: {
        numFactura: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
        dateEmision: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
        numExpediente: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.numExpediente && this.form.numExpediente.length > 20) {
                return callback(new Error(i18n.t('validation.length_max', { maxLength: 20 })))
              }
              callback()
            }
          }
        ],
        numEmisor: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.numEmisor && this.form.numEmisor.length > 20) {
                return callback(new Error(i18n.t('validation.length_max', { maxLength: 20 })))
              }
              callback()
            }
          }
        ],
        codAsignacion: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.codAsignacion && this.form.codAsignacion.length > 20) {
                return callback(new Error(i18n.t('validation.length_max', { maxLength: 20 })))
              }
              callback()
            }
          }
        ],
        dir3: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.dir3 && this.form.numContrato) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        numContrato: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.dir3 && !this.form.numContrato) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        periodoDesde: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.periodoDesde && this.form.periodoHasta) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        periodoHasta: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.periodoDesde && !this.form.periodoHasta) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        observaciones: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (value && /\*\*/.test(value)) {
                callback(new Error(i18n.t('invoices.invoices_issuing.step2.invalid_observations')))
              }
              if (!this.hasVerifactu) {
                if (!value) {
                  callback(new Error(i18n.t('invoices.invoices_issuing.step2.comentary_tax_validation')))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          }
        ],
      },
    }
  },
  computed: {
    ...mapGetters('invoicesIssuing', ['issuingType', 'issuingTypeStr', 'isInIssuingType']),
    isInInvoicesIssuingType: function () {
      return this.isInIssuingType(1)
    },
    isInProformaIssuingType: function () {
      return this.isInIssuingType(2)
    },
    isInQuotationIssuingType: function () {
      return this.isInIssuingType(3)
    },
    isInSimplifiedIssuingType: function () {
      return this.isInIssuingType(4)
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    getIdCliente: function () {
      return this.$store.getters['invoicesIssuing/form'].issuer.IdCliente
    },
    form: function () {
      return this.$store.getters[this.vuexnamespace + '/form']
    },
    getInvoiceNumber: function () {
      return this.$store.getters['invoicesIssuing/form'].numFactura
    },
    getSerialNumber: function () {
      return this.$store.getters['invoicesIssuing/form'].serieFactura
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isValid: function () {
      var step3Valid = true
      if (this.$refs['embedded-step']) {
        step3Valid = !!this.$refs['embedded-step']?.isValid
      }
      return this.form.numFactura !== '' && this.form.dateEmision !== null && this.form.dateEmision !== '' && step3Valid
    },
    idCIFEmpresa: function () {
      return this.$store.getters['invoicesIssuing/form']?.issuer?.IdCIFEmpresa || ''
    },
    receiverHasCoverSurcharge: function () {
      return !!this.$store.getters['invoicesIssuing/1/form']?.receiver?.Sociedad?.CoverEquivalenceSurcharge
    }
  },
  async mounted () {
    try {
      this.isLoadingSeries = true
      const response = await getSeries({ idCIFEmpresa: this.idCIFEmpresa || -1 })
      if (response.blnError) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        return
      }
      const series = response.Respuesta || []
      if (this.isInProformaIssuingType || this.isInQuotationIssuingType) {
        this.form.serieFactura = this.issuingTypeStr
        series.unshift(this.issuingTypeStr.toUpperCase())
      }
      if (!series.includes('')) series.unshift('')
      this.seriesFactura = series
      await this.getInvoiceSerialNumber(this.idCIFEmpresa || -1, this.form.serieFactura)
    } finally {
      this.isLoadingSeries = false
    }
    if (!this.form.dateEmision) {
      this.form.dateEmision = moment().format('yyyy-MM-DD[T00:00:00]')
    }
    if (typeof this.form.applyEquivalenceSurcharge !== 'boolean') {
      this.form.applyEquivalenceSurcharge = this.receiverHasCoverSurcharge
    }
  },
  watch: {
    'form.serieFactura': async function (value, oldValue) {
      if (value !== oldValue) {
        try {
          this.isLoadingSeries = true
          await this.getInvoiceSerialNumber(this.idCIFEmpresa || -1, value)
        } finally {
          this.isLoadingSeries = false
        }
      }
    },
    'form.applyEquivalenceSurcharge': async function (value, oldValue) {
      if (value !== oldValue) {
        if (value) this.form.tipoImpuestoFactura = 0
        if (this.$store.getters['invoicesIssuing/form'].invoiceLines?.length) {
          this.$store.getters['invoicesIssuing/form'].invoiceLines.forEach(line => {
            recalculate(line, value, this.form.tipoImpuestoFactura !== 0)
          })
        }
      }
    },
    'form.tipoImpuestoFactura': async function (value, oldValue) {
      if (value !== oldValue) {
        if (value !== 0) {
          this.form.applyEquivalenceSurcharge = false
          try {
            this.$store.commit('setIsLoading', true)
            // const params = { idCifEmpresa: this.idCifEmpresa }
            const id = this.$store.getters['invoicesIssuing/form'].issuer.IdCIFEmpresa || ''
            const data = await getValidateVerifactu({ idCifEmpresa: id })
            if (data.blnError) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
            } else {
              this.hasVerifactu = data.Respuesta
            }
          } finally {
            this.$store.commit('setIsLoading', false)
          }
        } else {
          this.hasVerifactu = true
        }
        if (this.$store.getters['invoicesIssuing/form'].invoiceLines?.length) {
          const taxName = this.$store.getters['config/TIPOS_OPERACION_TRIBUTACION'].find(x => x.id === value)?.name
          const zeroTax = {
            Name: taxName || value,
            TaxType: '01',
            TaxRate: 0,
            TaxCategory: 0,
            idImpuesto: -1
          }
          this.$store.getters['invoicesIssuing/form'].invoiceLines.forEach(line => {
            line.Taxes = [(value ? zeroTax : line.Impuestos[0]) || '']
            recalculate(line, this.form.applyEquivalenceSurcharge, value !== 0)
          })
        }
      }
    }
  },
  methods: {
    disabledFutureDates (date) {
      const today = moment().startOf('day')
      const selected = moment(date).startOf('day')
      return selected.isAfter(today)
    },
    validate: function (callback = (valid) => {}) {
      this.$refs.ruleForm.validate(valid => {
        this.$refs['embedded-step'].validate(async valid2 => {
          const params = {
            idCliente: this.value ? this.value : this.getIdCliente,
            idCIFEmpresa: this.idCIFEmpresa || null,
            serieFactura: this.form.serieFactura || null,
            numeroFactura: this.form.numFactura || null,
            fechaFactura: this.form.dateEmision || null
          }
          if (valid && valid2) {
            try {
              const data = await checkInvoiceNumber(params)
              if (data.blnError) {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
                callback(new Error(i18n.t('feedback.error.formated_api_response_error', data)))
              } else {
                callback(data.Respuesta, i18n.t('feedback.error.duplicated_invoicenumber_error'))
              }
            } catch {
              this.doFeedback(i18n.t('feedback.error.general'))
              callback(new Error(i18n.t('feedback.error.general')))
            }
          } else {
            callback(new Error())
          }
        })
      })
    },
    resetForm (excluded = []) {
      if (!excluded.includes(this.stepId)) {
        this.$store.dispatch(this.vuexnamespace + '/resetForm')
        this.$refs['embedded-step'].resetForm(excluded)
      }
    },
    clearPeriodo: function () {
      this.form.periodoDesde = ''
      this.form.periodoHasta = ''
    },
    validateFields (fields = [], value = '') {
      this.$refs.ruleForm.validateField(fields)
    },
    getInvoiceSerialNumber: async function (idCIFEmpresa, serieFactura = '') {
      var data = null
      if (this.isInInvoicesIssuingType) {
        const params = { idCIFEmpresa, serieFactura }
        data = await getNextInvoiceDefault(params)
      } else if (this.isInSimplifiedIssuingType) {
        // TODO -> Sugerencias de simplificadas
        const params = { idCIFEmpresa, serieFactura }
        data = await getNextInvoiceDefault(params)
      } else {
        const params = { idCIFEmpresa, serieFactura, suggestionFor: this.issuingTypeStr }
        data = await getNextInvoicePresupuestoProforma(params)
      }
      if (data.blnError === true) {
        const feedbackType = data.codError === 'GNID004' ? 'warning' : undefined
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data), feedbackType)
      }
      this.form.numFactura = data.respuesta?.InvoiceNumber || ''
    },
    serieFacturaLabel: function (option) {
      var entity = i18n.t('invoices.serie_factura_short')
      if (['de', 'eu'].includes(i18n.locale)) {
        entity = entity.toLowerCase()
      }
      return option || `(${i18n.t('app.select_entity_or_write_new_placeholder_long_f', { entity })})`
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
.aside-is-collapsed {
  .embedded-step::v-deep.content-wrapper {
    @include breakpoint(lg) {
      margin-left: 0;
    }
  }
}
.embedded-step::v-deep .lg\:max-w-detail {
  width: 100%;
  > div {
    padding: 0;
  }
}
</style>
<!-- <style scoped>
  ::v-deep .el-radio-button_inner{
    min-height: 3rem !important;
}
</style> -->
